import { Options } from 'src/app/model/options';

export const OPTIONS: Options[] = [
    {
        staticName: 'DRAW-CONTOUR',
        shortName: 'Draw roof borders',
        icon: 'fa-pencil-square-o',
        iconElement: 'draw',
        active: false,
        enabled: true,
        subOptions:null
        // [
        //     {
        //         staticName: 'DRAW-CONTOUR',
        //         shortName: 'Add new element',
        //         icon: 'assets/img/icons/add-element.png',
        //         iconElement: null,
        //         active: false,
        //         enabled: true,
        //         subOptions: null
        //     },
        //     {
        //         staticName: 'REMOVE-CONTOUR',
        //         shortName: 'Remove element',
        //         icon: 'assets/img/icons/remove-element.png',
        //         iconElement: null,
        //         active: false,
        //         enabled: true,
        //         subOptions: null
        //     }               
            
        // ]
    },    
        
    {
        staticName: 'ZONE-ROOF',
        shortName: 'Divide the roof into zones with different performance requirements',
        icon: 'fa-columns',
        iconElement: 'zones',
        active: false,
        enabled: true,
        subOptions: [
            {
                staticName: 'ZONE-ROOF-ADD',
                shortName: 'Add zone',
                icon: null,
                iconElement: null,
                active: false,
                enabled: true,
                subOptions: null
            }
        ]
    },
           
    {
        staticName: 'PROPERTIES',
        shortName: 'Define zone properties',
        icon: 'fa-list-alt',
        iconElement: 'properties',
        active: false,
        enabled: true,
        subOptions: null
    },
    

    {
        staticName: 'PRODUCTS',
        shortName: 'Automatic Product Selection',
        icon: 'fa-magic',
        iconElement: 'result',
        active: false,
        enabled: true,
        subOptions: null
    }
];
